<div class="monthly-head">
    <div>
        <h4 class="monthly-title">Monthly breakdown</h4>
        <p class="monthly-note">Spend by month for {{ periodLabel }}.</p>
    </div>
</div>
<div class="chart-container mb-4">
    <ppl-auth-bar-chart [data]="barChartData" [inputLabels]="barChartLabels" [stackedXAxis]="true"
        [stackedYAxis]="true" [labelValues]="'total'">
    </ppl-auth-bar-chart>
</div>
<div nz-row nzJustify="end" class="mb-2">
    <div nz-col nzspan="4">
        <ppl-button ariaLabel="Download" label="Export to excel"
            icon="fa fa-download" [customClass]="'primary-button'"
            [iconPosition]="'left'" (click)="exportToExcel()"></ppl-button>
    </div>
</div>
<div style="text-align: center;font-size: 14px;" class="table-wrapper">
    <table class="table table-bordered table-sm monthly-spending-summary-table">
        <thead>
            <tr>
                <th>
                    Spending Plan
                </th>
                <th>
                    Category
                </th>
                <th>
                    Service Code & Description
                </th>
                <th>
                    Budgeted
                </th>
                <th *ngFor="let month of availableMonthYearsData">
                    {{month}}
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let data of monthlySpendingData">
                <tr>
                    <td>{{data.clientAuthNumber}}</td>
                    <td>{{data.categoryName}}</td>
                    <td>{{data.code}} | {{data.description}}</td>
                    <td>{{data.totalAuth | currency}}</td>
                    <td
                        *ngFor="let monthYear of availableMonthYearsData">{{data.monthlyMap?.get(monthYear)?.spent
                        ?? 0 | currency}}</td>
                </tr>
            </ng-container>
            <tr class="total-row">
                <td>Total
                    Budget</td>
                <td></td>
                <td></td>
                <td>{{totalBudgetedAmount | currency}}</td>
                <td *ngFor="let monthYear of availableMonthYearsData">
                    {{totalMonthlySpentMap.get(monthYear) ?? 0 | currency}}
                </td>
            </tr>
        </tbody>
    </table>
</div>
